import type { CarrierDetails } from "../types";

export const MOCK_CARRIER_DETAILS: CarrierDetails = {
  rfpsInExtract: 1284,
  rules: 8,
  group: "Guardian Life",
};
